import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import angular from 'angular';

export const EventsControllerModule = angular.module('acme.view.events.controllers', [
  ThemesServiceModule
])

.controller('EventsController', ['$scope', 'ThemesService', 'ThemesData', function($scope, ThemesService, ThemesData) {

    $scope.events = {

      init: function() {
        if (ThemesData.data && ThemesData.data.success) {
          this.success.initTheme(ThemesData);
        }else{
          this.error.initTheme(ThemesData);
        }
      },

      success: {
        initTheme: function(response) {
          ThemesService.model = response.data.payload;
        }
      },

      error: {
        initTheme: function(response) {}
      }

    };

    $scope.events.init();


}]).name;